import React from 'react';

class screenComponent extends React.Component {
    constructor(props) {
		super(props);
	}
    render() {
        let { title, content } = this.props.route;

        return (
            <div className='static-content'>
                <h1>{ title ? title : 'Default screen'}</h1>
                { content || ''}
            </div>
        )
    }
}

export default screenComponent;



// WEBPACK FOOTER //
// ./source/screens/Default.js